import favicon from '../assets/photos/logo-blue-120.png';

const title = 'Hopin Website';
const description =
  'Hopin is a transportation logistics company that helps daily commuters get to work.';

export const helmet = {
  title,
  titleTemplate: '%s - Hopin',
  htmlAttributes: { lang: 'en' },
  meta: [
    { name: 'description', content: description },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, user-scalable=no',
    },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    { name: 'msapplication-navbutton-color', content: '#000' },
    { name: 'msapplication-TileColor', content: '#000' },
    { name: 'theme-color', content: '#000' },

    { name: 'twitter:title', content: title },
    { name: 'twitter:site', content: '@hopintech' },
    { name: 'twitter:creator', content: '@hopintech' },
    { name: 'twitter:description', content: description },
  ],
  link: [{ rel: 'icon', type: 'image/x-icon', href: favicon }],
};
